import { useEffect, useState } from "react";
import {
  FundProjectionScreenOutlined,
  IdcardOutlined,
  PlusCircleOutlined,
  ProjectOutlined,
  UnorderedListOutlined,
  FileTextOutlined,
  RiseOutlined,
  UserOutlined,
  DashboardOutlined,
  FolderOpenOutlined,
  BuildOutlined
} from "@ant-design/icons";
import { Menu } from "antd";
import SubMenu from "antd/lib/menu/SubMenu";
import { useNavigate } from "react-router-dom";

import { useRoles } from "../../hooks/useRoles";
import { useUser } from "../../hooks/useUsers";
import { useProjects } from "../../hooks/useProjects";
import { useLogged } from "../../hooks/userLogin";
import packageJson from '../../../package.json';

import {
  Sidebar,
  LogoContainer,
} from './styles'
import { useCompanies } from "../../hooks/useCompanies";

export default function LateralBar() {
  const { user } = useLogged();
  const [collapsed, setCollapsed] = useState(false);
  const [logo, setLogo] = useState<string | undefined>('');
  const navigate = useNavigate();

  const { permissions, handleModalVisible: rolesHandleModalVisible } = useRoles();
  const { handleModalVisible: usersHandleModalVisible } = useUser();
  const { handleModalVisible: companiesHandleModalVisible } = useCompanies();
  const projects = useProjects();
  const auth = useLogged();

  console.log('permissions');
  console.log(permissions);

  const MenuToDefaultUser = function() {
    const listUser =
      permissions.filter((item) => item.name === "editUser").length > 0;
    const newUser =
      permissions.filter((item) => item.name === "editUser").length > 0;
    const listRoles =
      permissions.filter((item) => item.name === "listRole").length > 0;
    const newRole =
      permissions.filter((item) => item.name === "editRole").length > 0;
    const listTemplates =
      permissions.filter((item) => item.name === "listTemplates").length > 0;
    const editTemplates =
      permissions.filter((item) => item.name === "editTemplates").length > 0;
    const listProjects =
      permissions.filter((item) => item.name === "listProjects").length > 0;
    const newProjects =
      permissions.filter((item) => item.name === "editProject").length > 0;
    const listReports =
      permissions.filter((item) => item.name === 'listReports').length > 0;
    const listTemplateCivilTypes =
      permissions.filter((item) => item.name === 'listTemplateCivilTypes').length > 0;
    const editTemplateCivilTypes =
      permissions.filter((item) => item.name === 'editTemplateCivilTypes').length > 0;
    const listTemplateOperationTypes =
      permissions.filter((item) => item.name === 'listTemplateOperationTypes').length > 0;
    const editTemplateOperationTypes =
      permissions.filter((item) => item.name === 'editTemplateOperationTypes').length > 0;
    const clientView =
      permissions.filter((item) => item.name === 'clientView').length > 0;

    return (
      <Menu
        theme="light"
        mode="inline"
        className="menus"
      >
        {listUser && (
          <SubMenu key="users" icon={<UserOutlined />} title="Usuários">
            <Menu.Item key="users-list" onClick={() => navigate("/users/1")}>
              <UnorderedListOutlined />
              <span className="menu-item-title">Listagem</span>
            </Menu.Item>

            {newUser && (
              <Menu.Item key="users-new" onClick={() => usersHandleModalVisible(true)}>
                <PlusCircleOutlined />
                <span className="menu-item-title">Novo usuário</span>
              </Menu.Item>
            )}
          </SubMenu>
        )}

        {listRoles && (
          <SubMenu key="groups" icon={<IdcardOutlined />} title="Grupos">
            <Menu.Item key="groups-list" onClick={() => navigate("/groups/1")}>
              <UnorderedListOutlined />
              <span className="menu-item-title">Listagem</span>
            </Menu.Item>

            {newRole && (
              <Menu.Item key="groups-new" onClick={() => rolesHandleModalVisible(true)}>
                <PlusCircleOutlined />
                <span className="menu-item-title">Novo grupo</span>
              </Menu.Item>
            )}
          </SubMenu>
        )}

        {/* {listTemplateOperationTypes && ( */}
          <SubMenu key="template-civil-types" icon={<IdcardOutlined />} title="Tipos civis">
            <Menu.Item key="template-civil-types-list" onClick={() => navigate("/template-civil-types/1")}>
              <UnorderedListOutlined />
              <span className="menu-item-title">Listagem</span>
            </Menu.Item>

            {/* {editTemplateCivilTypes && ( */}
              <Menu.Item key="template-civil-types-new" onClick={() => navigate("/create/template-civil-types")}>
                <PlusCircleOutlined />
                <span className="menu-item-title">Novo tipo</span>
              </Menu.Item>
            {/* )} */}
          </SubMenu>
        {/* )} */}

        {/* {listTemplateCivilTypes && ( */}
          <SubMenu key="template-operation-types" icon={<IdcardOutlined />} title="Tipos operacionais">
            <Menu.Item key="template-operation-types-list" onClick={() => navigate("/template-operation-types/1")}>
              <UnorderedListOutlined />
              <span className="menu-item-title">Listagem</span>
            </Menu.Item>

            {/* {editTemplateOperationTypes && ( */}
              <Menu.Item key="template-operation-types-new" onClick={() => navigate("/create/template-operation-types")}>
                <PlusCircleOutlined />
                <span className="menu-item-title">Novo tipo</span>
              </Menu.Item>
            {/* )} */}
          </SubMenu>
        {/* )} */}

        {listTemplates && (
          <SubMenu key="templates" icon={<FundProjectionScreenOutlined />} title="Templates" >
            <Menu.Item key="templates-list" onClick={() => navigate("/templates/1")}>
              <UnorderedListOutlined />
              <span className="menu-item-title">Listagem</span>
            </Menu.Item>

            {editTemplates && (
              <Menu.Item key="templates-new" onClick={() => navigate("/create/template")}>
                <PlusCircleOutlined />
                <span className="menu-item-title">Novo template</span>
              </Menu.Item>
            )}
          </SubMenu>
        )}

        {listProjects && (
          <SubMenu key="projects" icon={<ProjectOutlined />} title="Projetos" >
            <Menu.Item key="projects-list" onClick={() => navigate("/projects/1")}>
              <UnorderedListOutlined />
              <span className="menu-item-title">Listagem</span>
            </Menu.Item>

            {newProjects && (
              <Menu.Item key="projects-new" onClick={() => projects.handleModalVisible(true)}>
                <PlusCircleOutlined />
                <span className="menu-item-title">Novo Projeto</span>
              </Menu.Item>
            )}
          </SubMenu>
        )}

        <SubMenu  key="reports"  icon={<FileTextOutlined />} title="Relatórios" >
            <Menu.Item key="reports" onClick={() => navigate("/reports/1")}>
              <UnorderedListOutlined />
              <span className="menu-item-title">Tabela</span>
            </Menu.Item>

            <Menu.Item key="reports/highcharts" onClick={() => navigate("/reports/highcharts")}>
              <RiseOutlined />
              <span className="menu-item-title">Gráfico</span>
            </Menu.Item>
        </SubMenu>

        <Menu.Item key="dashboard" onClick={() => navigate("/dashboard")} >
            <DashboardOutlined />
            <span className="menu-item-title">Dashboard</span>
        </Menu.Item>

        {/* { clientView && ( */}
          <Menu.Item key="clientView" onClick={() => navigate("/client-view")} >
              <DashboardOutlined />
              <span className="menu-item-title">Visão do cliente</span>
          </Menu.Item>
        {/* )} */}

        <Menu.Item key="general" onClick={() => navigate("/general")} >
          <ProjectOutlined />
            <span className="menu-item-title">Visão Geral</span>
        </Menu.Item>

        <Menu.Item key="my-tasks" onClick={() => navigate("/reports/1/" + auth.user.id)} >
          <FolderOpenOutlined />
            <span className="menu-item-title">Minhas tarefas</span>
        </Menu.Item>
      </Menu>
    )
  }

  const MenuToSuperAdminUser = function() {
    return (
      <Menu
        theme="light"
        mode="inline"
        className="menus"
      >
        <SubMenu key="companies" icon={<BuildOutlined />} title="Empresas">
            <Menu.Item key="companies-list" onClick={() => navigate("/companies/1")}>
              <UnorderedListOutlined />
              <span className="menu-item-title">Listagem</span>
            </Menu.Item>

            <Menu.Item key="companies-new" onClick={() => companiesHandleModalVisible(true)}>
              <PlusCircleOutlined />
              <span className="menu-item-title">Nova empresa</span>
            </Menu.Item>
        </SubMenu>

        <SubMenu key="users" icon={<UserOutlined />} title="Usuários">
            <Menu.Item key="users-list" onClick={() => navigate("/users/1")}>
              <UnorderedListOutlined />
              <span className="menu-item-title">Listagem</span>
            </Menu.Item>

            <Menu.Item key="users-new" onClick={() => usersHandleModalVisible(true)}>
              <PlusCircleOutlined />
              <span className="menu-item-title">Novo usuário</span>
            </Menu.Item>
        </SubMenu>
      </Menu>
    )
  }

  useEffect(() => {
    setLogo(auth.user.company ? auth.user.company.logo : '');
  }, [])

  return (
    <Sidebar
      collapsible
      collapsed={collapsed}
      onCollapse={setCollapsed}
      className="sidebar"
    >
      {
        logo && (
          <LogoContainer collapsed={collapsed}>
            <img
              src={logo || ''}
              alt='Logo da empresa'
              className="logo"
              onClick={() => navigate("/")}
            />
          </LogoContainer>
        )
      }

      {
        user.company
          ? <MenuToDefaultUser />
          : <MenuToSuperAdminUser />
      }
      {/* Versão do sistema no final da sidebar */}
      <div style={{
        position: 'absolute',
        bottom: 50,
        width: '100%',
        textAlign: 'center',
        fontSize: '0.75rem',
        color: '#888',
        opacity: 0.7
      }}>
        v{packageJson.version}
      </div>
    </Sidebar>
  );
}
